var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowReturn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2617 22.3274C25.2617 20.4173 22.9175 19.4121 21.4906 20.8195L15.1716 26.9516C14.3562 27.7558 14.3562 29.1632 15.1716 30.0679L21.4906 36.3006C22.9175 37.7079 25.2617 36.7027 25.2617 34.7927C25.2617 33.5863 26.2809 32.5811 27.5039 32.5811H39.5305C40.7535 32.5811 41.7727 31.5758 41.7727 30.3695V26.65C41.7727 25.4437 40.7535 24.4384 39.5305 24.4384L27.5039 24.4384C26.2809 24.4384 25.2617 23.5337 25.2617 22.3274Z",
    fill: "#FE5000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowReturn);
export default __webpack_public_path__ + "static/media/arrow-return.d6a12f5a.svg";
export { ForwardRef as ReactComponent };